module.exports = __webpack_public_path__ + "static/media/blue_plus.bad3ef48.png";